










import { defineComponent, computed, PropType } from '@vue/composition-api';
import { bemx } from '@berlin-front/common/utils';

/**
 * 空っぽの汎用Routeを構成するためのコンポーネント。
 *
 * VueRouterのネストしたルートで親として使用し、通常はここで子と共有するコンテキストプロバイダを設定する。
 * 無闇にグローバルコンテキストを使用せずに、限定された子の間だけでコンテキストを共有できる。
 */
export default defineComponent({
  name: 'AppDetails',

  props: {
    /** ヒント */
    hint: {
      type: String,
      default: '',
    },

    /** エラーメッセージ */
    errorMessages: {
      type: Array as PropType<string[]>,
      default: () => [] as string[],
    },

    /** 最大エラー表示数 */
    errorCount: {
      type: Number,
      default: 1,
    },
  },

  setup(props) {
    const hasErrors = computed(() => props.errorMessages.length > 0);
    const messages = computed(
      () =>
        (hasErrors.value ? props.errorMessages : [props.hint])
          .filter((msg) => msg) // 空データの除去
          .filter((msg, idx, all) => all.indexOf(msg) === idx) // 重複削除。
          .slice(0, props.errorCount), // 表示エラー数調整。
    );

    const styles = computed(() =>
      bemx('AppDetails', {
        'has-errors': hasErrors.value,
      }),
    );

    return {
      hasErrors,
      messages,
      styles,
    };
  },
});
